import React from 'react'

const RemoteImage = () => {
    return (
        <img src="./assets/svg/doctor_remote.svg" alt="remote" className="width-100 height-100" />
    )
}

export default React.memo( RemoteImage )